import { contextFactory, ResortIdEnum } from '@alluradirect/react';

export const listFormContextInitialValues = {
  resort_id: ResortIdEnum.Whistler,
  email: '',
  lastName: '',
  firstName: '',
  listingUrl: '',
};

type ListFormValues = typeof listFormContextInitialValues;

interface Context {
  listFormValues: ListFormValues;
  setListFormValues: React.Dispatch<React.SetStateAction<ListFormValues>>;
}

export const { useContext: useListModalContext, ContextProvider: ListModalContextProvider } = contextFactory<Context>();
